var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"active":_vm.isActive},on:{"cancel":_vm.handleModal_Cancel}},[_c('v-zoomer',{staticStyle:{"height":"200px","width":"300px"}},[(_vm.isLocal)?[_c('img',{attrs:{"src":_vm.src}})]:[_c('ik-image',{attrs:{"path":_vm.src}})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }